
import { Vue, Options } from "vue-class-component";
@Options({
  props: {
    title: String,
    right1Items: String,
    right2Items: String
  },
  emits: {
    right1action: () => {
      return true;
    },
    right2action: () => {
      return true;
    }
  }
})
export default class Nav extends Vue {
  navBack() {
    // this.$router.go(-1);
    this.$router.back();
  }
}
